import { Entity } from '../entity';

export enum MaterialisedViewRunStatus {
    Idle = 'idle',
    Running = 'running',
    Completed = 'completed',
    Failed = 'failed'
}

export enum MaterialisedViewRunMode {
    Incremental = 'incremental',
    Rebuild = 'rebuild'
}

export interface MaterialisedViewState extends Entity {
    configId: string;
    status: MaterialisedViewRunStatus;
    lastRunAt?: Date;
    nextRunAt?: Date;
    lastUpdatedAt?: Date;
    lastId?: string;
    lastProcessed?: number;
    lastDeleted?: number;
    lastDurationMs?: number;
    leaseExpiresAt?: Date;
    runId?: string;
    requestedMode?: MaterialisedViewRunMode;
    requestedAt?: Date;
    lastError?: string;
}
